import React from "react";
import { Navigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";

interface ProtectedRouteProps {
  children: React.ReactElement;
  allowedRoles?: string[];
}

const ROLE_HOME: Record<string, string> = {
  admin:                "/dashboard/manager",
  manager:              "/dashboard/manager",
  frontdesk:            "/dashboard/manager",
  reception:            "/dashboard/manager",
  restaurant:           "/dashboard/restaurant",
  spa:                  "/dashboard/spa",
  room_service:         "/dashboard/roomservice",
  room_service_manager: "/dashboard/roomservice/manager",
};

function clearSession() {
  ["ai2_token", "ai2_role", "ai2_name", "ai2_hotel"].forEach(k => localStorage.removeItem(k));
}

export default function ProtectedRoute({ children, allowedRoles }: ProtectedRouteProps) {
  const token = localStorage.getItem("ai2_token");
  const role  = localStorage.getItem("ai2_role");

  if (!token || !role) {
    return <Navigate to="/dashboard/login" replace />;
  }

  // Reject expired tokens immediately so the dashboard never loads with stale auth
  try {
    const { exp } = jwtDecode<{ exp: number }>(token);
    if (exp * 1000 < Date.now()) {
      clearSession();
      return <Navigate to="/dashboard/login" replace />;
    }
  } catch {
    clearSession();
    return <Navigate to="/dashboard/login" replace />;
  }

  // admin can access any route
  if (allowedRoles && role !== "admin" && !allowedRoles.includes(role)) {
    return <Navigate to={ROLE_HOME[role] || "/dashboard/login"} replace />;
  }

  return children;
}
